import React from "react";
import { ChevronRight } from "lucide-react";

export default function LaunchChecklistItem({
    title,
    checked,
    onToggle,
    onAction,
    icon: Icon,
}) {
    return (
        <div className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:border-blue-200 hover:shadow-sm transition-all">
            <button
                onClick={onToggle}
                className="flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors cursor-pointer"
                style={{
                    borderColor: checked ? "#16a34a" : "#d1d5db",
                    backgroundColor: checked ? "#16a34a" : "transparent",
                }}
            >
                {checked && (
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                )}
            </button>
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center">
                <Icon className="w-4 h-4 text-blue-600" />
            </div>
            <button
                onClick={onAction}
                className="flex-1 flex items-center justify-between text-left cursor-pointer group"
            >
                <span className={`text-sm font-medium transition-colors ${checked ? "line-through text-gray-400" : "text-gray-900 group-hover:text-blue-600"}`}>
                    {title}
                </span>
                <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors" />
            </button>
        </div>
    );
}
